<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-body v-if="shouldShowData">
        <div class="row">
          <div class="col-md-12">
            <label>Nombre</label>
            <base-input v-model="Name" placeholder="Escribí Nombre del Cajero"></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label>Apellido</label>
            <base-input v-model="Surname" placeholder="Escribí Apellido del Cajero"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-10">
            <label>Mail</label>
            <base-input
              v-model="Mail"
              name="email"
              placeholder="Ejemplo: mail@mail.com"
              :disabled="AccountID > 0"
            ></base-input>
            <!-- <span class="validation-error">{{ errors.first('email') }}</span> -->
          </div>

          <div
            v-if="AccountID > 0"
            class="col-xl-2"
            style="display: flex; align-items:center; padding-top: 10px;"
          >
            <b-button
              variant="outline-success"
              class="btnValidar"
              style="width:100% !important"
              @click="emailValidation"
            >Cambiar</b-button>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-3">
            <label>Prefijo</label>
            <base-input
              v-model="Prefix"
              type="number"
              onlyNumbers
              :maxlength="5"
              placeholder="Prefijo"
              :disabled="AccountID > 0"
            ></base-input>
          </div>
          <div class="col-md-7">
            <label>Número</label>
            <base-input v-model="Telephone" placeholder="Número" :disabled="AccountID > 0"></base-input>
          </div>
          <div
            v-if="AccountID > 0"
            class="col-xl-2"
            style="display: flex; align-items:center; padding-top: 10px;"
          >
            <b-button
              variant="outline-success"
              class="btnValidar"
              style="width:100% !important"
              @click="phoneValidation"
            >Cambiar</b-button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label>DNI</label>
            <base-input
              v-model="DocumentNumber"
              autocomplete="off"
              placeholder="Escribí DNI del Cajero"
              :disabled="AccountID > 0 && DocumentNumberEmpty == false"
            ></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label>Usuario</label>
            <base-input v-model="UserName" autocomplete="off" placeholder="Ejemplo: Roman10"></base-input>
          </div>
        </div>
        <div style="margin-bottom:20px; color:red">
          <div v-if="!isValidUserName">El nombre de usuario debe contener al menos una letra</div>
        </div>

        <!-- <div class="row">
          <div class="col-md-12">
            <label>Password</label>
            <base-input v-model="Password" type="password" autocomplete="off"></base-input>
          </div>
        </div>-->

        <div class="row">
          <div class="col-md-12">
            <label>Password</label>
            <password-validator
              v-model="Password"
              @password-validated="updatePasswordValidity"
              placeholder="Password"
            ></password-validator>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label>Repetir Password</label>
            <base-input
              v-model="PasswordRepeat"
              type="password"
              addon-left-icon="fa fa-fw fa-unlock-alt"
              autocomplete="off"
            ></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label>Sucursales</label>

            <!-- <multiselect
              v-model="sucursalesElegidas"
              :options="sucursales"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Elija sucursales"
              label="Name"
              track-by="Name"
              :preselect-first="false"
              selectLabel
              deselectLabel
            >
              <label class="typo__label">Tagging</label>
            </multiselect>-->

            <KitsComboMultiple
              propertyName="Name"
              v-model="sucursalesElegidas"
              :items="sucursales"
              placeholder="Seleccione sucursales"
              propertyID="EntityID"
              :currentItems="Branchs"
            ></KitsComboMultiple>
          </div>
        </div>

        <div class="row" style="margin-top:20px;margin-bottom:20px;">
          <div class="col-md-12">
            <b-form-checkbox v-model="Restricted">Restriccion Horaria</b-form-checkbox>
          </div>
        </div>

        <div
          style=" border: 1px solid #e4e4e4; padding-top: 15px; padding-bottom: 15px;"
          v-if="Restricted"
        >
          <b-card style="margin: 20px">
            <div class="row">
              <div class="col-md-3">
                <label>Día</label>
                <KitsCombo
                  v-model="WeekDayID"
                  v-bind:items="days"
                  propertyName="Name"
                  propertyID="EntityID"
                  :todos="false"
                ></KitsCombo>
              </div>

              <div class="col-md-3">
                <label>Hora desde</label>
                <CashHoursCombo hasEmptyOption v-bind:selectedvalue.sync="HourFrom"></CashHoursCombo>
              </div>

              <div class="col-md-3">
                <label>Hora hasta</label>
                <CashHoursCombo
                  hasEmptyOption
                  v-bind:selectedvalue.sync="HourTo"
                  firsItemText="Ej. Horario Cierre"
                ></CashHoursCombo>
              </div>

              <div class="col-md-3 text-center" style="margin-top:24px;">
                <button @click="agregarHorario" class="btn btn-warning btn-lg">
                  <i class="fa fa-plus fa-fw"></i>Agregar horario
                </button>
              </div>
            </div>
          </b-card>
          <div
            class="col-12"
            style="margin-top: 5px"
            v-for="(item, index) in Schedule"
            v-bind:key="item.CashierScheduleID"
            :value="item.CashierScheduleID"
          >
            <div class="col-12" style="display: flex" v-bind:class="{'impar': index%2==0 }">
              <div class="col-md-1" style=" text-align: center;margin-top: 9px;">
                <span class="fa fa-fw fa-clock" />
              </div>
              <div class="col-md-6 col-lg-9">
                <div class="pull-left">
                  {{item.WeekDayName}}
                  <br />
                  <span style="font-size: 13px;">Desde: {{item.HourFrom}} hasta {{item.HourTo}}</span>
                </div>
              </div>
              <div class="col-md-1">
                <button
                  @click="borrarHorario(index)"
                  class="btn btn-danger btn-xs"
                  style="margin-top: 5px;
    margin-bottom: 5px;"
                >
                  <i class="fa fa-trash fa-fw"></i>
                </button>
              </div>
            </div>
            <!-- {{item.WeekDayName}} de {{item.HourFrom}} a {{item.HourTo}}
            <button
              @click="borrarHorario(index)"
              class="btn btn-danger btn-xs"
            >Borrar</button>-->
          </div>
        </div>

        <div class="row form-group" style="margin-top:10px;">
          <div class="col-md-12">
            <button @click="goBack" class="btn btn-danger btn-lg">Volver</button>
            <save-button @click="addUpdate"></save-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.impar {
  background-color: #ededed;
}
</style>
<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import KitsCombo from "@/components/KitsCombo";
import KitsComboMultiple from "@/components/KitsComboMultiple";
import Multiselect from "vue-multiselect";
import CashHoursCombo from "@/components/Specific/Combos/CashHoursCombo.vue";
import PasswordValidator from "@/components/Custom/PasswordValidator";

export default {
  name: "crearcajero",
  props: {
    title: String,
    EntityIDProp: Number
  },
  directives: {},
  components: {
    KitsCombo,
    Multiselect,
    KitsComboMultiple,
    CashHoursCombo,
    PasswordValidator
  },

  data() {
    return {
      AccountID: this.EntityIDProp,
      Name: "",
      Surname: "",
      Mail: "",
      Prefix: "",
      Telephone: "",
      DocumentNumber: null,
      DocumentNumberEmpty: true,
      UserName: "",
      Password: "",
      PasswordRepeat: "",
      passwordIsValid: false,
      Restricted: false,
      Schedule: [],
      Branchs: [],
      HourFrom: 0,
      HourTo: 0,
      hours: [],
      days: [],
      sucursales: [],
      sucursalesElegidas: [],
      WeekDayID: 0,
      ready: false,
      getDataComplete: false,
      isValidUserName: true,
    };
  },
  computed: {
    shouldShowData() {
      return this.AccountID === 0 || this.getDataComplete;
    }
  },
  methods: {
    updatePasswordValidity(isValid) {
      let context = this;
      context.passwordIsValid = isValid;
    },

    emailValidation() {
      let context = this;

      //-- Indica si tiene que Verificación de 2 pasos activa
      if (context.$store.getters.ShouldPerformTwoStepVerification == true) {
        context.$router.push({
          name: "selectSecurityMethod",
          params: {
            accumulationMethodTypeID:
              context.$store.getters
                .PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
            useRouterPush: true,
            dataPost: {
              name: "EmailModification",
              params: {
                url: "/crearcajero",
                accountID: context.AccountID
              }
            }
          }
        });
      } else {
        context.$router.push({
          name: "EmailModification",
          params: {
            url: "/crearcajero",
            accountID: context.AccountID
          }
        });
      }
    },
    phoneValidation() {
      let context = this;
      //-- Indica si tiene que Verificación de 2 pasos activa
      if (context.$store.getters.ShouldPerformTwoStepVerification == true) {
        context.$router.push({
          name: "selectSecurityMethod",
          params: {
            accumulationMethodTypeID:
              context.$store.getters
                .PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
            useRouterPush: true,
            dataPost: {
              name: "PhoneModification",
              params: {
                url: "/crearcajero",
                accountID: context.AccountID
              }
            }
          }
        });
      } else {
        context.$router.push({
          name: "PhoneModification",
          params: {
            Prefix: context.model.Prefix,
            Telephone: context.model.Telephone,
            url: "/crearcajero",
            accountID: context.AccountID
          }
        });
      }
    },

    isUpdate() {
      return this.AccountID > 0;
    },

    goBack() {
      this.$router.push("cajeros");
    },

    getData() {
      let context = this;
      if (context.AccountID > 0) {
        axiosHelpers.axiosGet(
          "Commerce/CashierManagementSaveGet",
          { AccountID: context.AccountID },
          context,
          function(data) {
            context.Name = data.ResponseVM.Name;
            context.Surname = data.ResponseVM.Surname;
            context.UserName = data.ResponseVM.UserName;
            context.Mail = data.ResponseVM.Mail;
            context.DocumentNumber = data.ResponseVM.DocumentNumber;
            context.DocumentNumberEmpty =
              data.ResponseVM.DocumentNumber == null ||
              data.ResponseVM.DocumentNumber == "";
            context.Prefix = data.ResponseVM.Prefix;
            context.Telephone = data.ResponseVM.Telephone;
            context.Password = data.ResponseVM.Password;
            context.PasswordRepeat = data.ResponseVM.Password;
            context.Restricted = data.ResponseVM.Schedule.length > 0;
            context.Schedule = data.ResponseVM.Schedule;

            context.Branchs = [];
            for (let i = 0; i < context.sucursales.length; i++) {
              for (let j = 0; j < data.ResponseVM.BranchOffices.length; j++) {
                if (
                  context.sucursales[i].EntityID ==
                  data.ResponseVM.BranchOffices[j]
                ) {
                  context.Branchs.push(context.sucursales[i]);
                }
              }
            }
            context.sucursalesElegidas = context.Branchs;

            context.passwordIsValid = true;
            context.getDataComplete = true;
          }
        );
      }
    },
    addUpdate() {
      let self = this;

      if (this.Password != this.PasswordRepeat) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Las contraseñas deben coincidir",
          self
        );
        return;
      }

      if (self.passwordIsValid == false) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "La contraseña no es correcta",
          self
        );
        return;
      }

      if(self.isValidUserName == false){
        return;
      }

      axiosHelpers.axiosPost(
        "Commerce/CashierManagementSave",
        this.getDataToRequest(),
        this,
        function(response) {
          var hasError = axiosHelpers.getResponseHasErrors(response);

          if (response.ResponseVM.Result) {
            notificationHelpers.showSuccess(
              "Exito",
              "Se guardó el cajero correctamente.",
              self
            );
            self.$router.push({ name: "cajeros" });
          }
        }
      );
    },
    agregarHorario() {
      let context = this;
      if (this.HourFrom >= this.HourTo) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "La hora desde debe ser inferior a la hora hasta",
          context
        );
        return;
      }
      let dayName = "";

      for (let i = 0; i < context.Schedule.length; i++) {
        var element = context.Schedule[i];
        if (element.WeekDayID == context.WeekDayID) {
          if (
            context.HourFrom <= element.HourFrom &&
            context.HourTo >= element.HourFrom
          ) {
            notificationHelpers.showWarning(
              "Advertencia!",
              "Ese rango se superpone con otro",
              context
            );
            return;
          } else if (
            context.HourFrom >= element.HourFrom &&
            context.HourTo <= element.HourTo
          ) {
            notificationHelpers.showWarning(
              "Advertencia!",
              "Ese rango se superpone con otro",
              context
            );
            return;
          }
        }
      }

      for (let i = 0; i < context.days.length; i++) {
        if (context.WeekDayID == context.days[i].EntityID) {
          dayName = context.days[i].Name;
          break;
        }
      }

      context.Schedule.push({
        WeekDayID: context.WeekDayID,
        HourFrom: context.HourFrom,
        HourTo: context.HourTo,
        WeekDayName: dayName,
        CashierScheduleID: 0
      });
      context.HourFrom = 0;
      context.HourTo = 0;
      context.WeekDayID = context.days[0].EntityID;
    },
    borrarHorario(index) {
      this.Schedule.splice(index, 1);
    },
    getDataToRequest() {
      let branch = [];
      for (let i = 0; i < this.sucursalesElegidas.length; i++) {
        branch.push(this.sucursalesElegidas[i].EntityID);
      }

      var scheduleSave = [];

      if (this.Restricted) scheduleSave = this.Schedule;

      return {
        AccountID: this.AccountID,
        UserName: this.UserName,
        Name: this.Name,
        Surname: this.Surname,
        Mail: this.Mail,
        DocumentNumber: this.DocumentNumber,
        Prefix: this.Prefix,
        Telephone: this.Telephone,
        Password: this.Password,
        Schedule: scheduleSave,
        BranchOffices: branch
      };
    },
    validateUserName(){
      let context = this;

      const regexUpperCase = /[A-Z]/;
      const regexLowerCase = /[a-z]/;

      context.isValidUserName = regexUpperCase.test(context.UserName) || regexLowerCase.test(context.UserName);
    }
  },

  beforeMount: function() {
    let context = this;

    axiosHelpers.axiosGet("WeekDay/GetAll", {}, this, function(data) {
      context.days = data.ResponseVM;
    });

    axiosHelpers.axiosPost("Commerce/GetBranchOffices", {}, this, function(
      data
    ) {
      context.sucursales = data.ResponseVM.Items;
      context.ready = true;
    });
  },
  watch: {
    ready: function(newValue, oldValue) {
      this.getData();
    },
    UserName: function(newValue, oldValue) {
      this.validateUserName();
    } 
  }
};
</script>
<style></style>
